import React from 'react';
import { pains } from '../data/content';
export function PainAgitation() {
  return <section aria-labelledby="dolor" className="w-full bg-ink" data-id="element-82" data-mp="ae0rnjd07zcf">
      <div className="mx-auto max-w-6xl px-6 py-16 lg:py-24 lg:px-10" data-id="element-83" data-mp="afve523xbzim">
        <h2 id="dolor" className="max-w-2xl font-display text-3xl font-semibold leading-tight text-ivory sm:text-[2.6rem]" data-id="element-84" data-mp="oebhqk6hp9wj">
          Sabemos exactamente por lo que estás pasando
        </h2>

        <ul className="mt-12 grid grid-cols-1 gap-x-12 gap-y-10 sm:grid-cols-2" data-id="element-85" data-mp="y9v9qvhxnog0">
          {pains.map((pain, i) => <li key={pain.title} className="grid grid-cols-[auto_1fr] gap-x-5" data-id="element-86" data-mp="tasf84zkx0ma" data-mpi={i}>
              <span aria-hidden="true" className="font-display text-xl text-terracotta" data-id="element-87" data-mp="183lxtza5dwv6">
                0{i + 1}
              </span>
              <div data-id="element-88" data-mp="1h2quf025fg4p">
                <h3 className="font-display text-2xl text-ivory" data-id="element-89" data-mp="1h04rjdq7dost">{pain.title}</h3>
                <p className="mt-2 font-sans text-base leading-relaxed text-ivory/65" data-id="element-90" data-mp="1c4paye0t9esp">
                  {pain.body}
                </p>
              </div>
            </li>)}
        </ul>

        <p className="mt-14 max-w-2xl border-t border-ivory/15 pt-8 font-display text-2xl leading-snug text-ivory sm:text-3xl" data-id="element-91" data-mp="1y6u3ev0c4jm0">
          Tú no te mereces una boda que se sienta como un compromiso.{' '}
          <em className="italic text-terracotta" data-id="element-92" data-mp="285t49reuzayg">Te mereces una celebración épica.</em>
        </p>
      </div>
    </section>;
}